import { render } from "./TwoFactorLayout.vue?vue&type=template&id=58ec3c49"
import script from "./TwoFactorLayout.vue?vue&type=script&lang=js"
export * from "./TwoFactorLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__